import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { RenovacionService } from "./renovacion.service";
import { UtilService } from "../../../components/common/utils/util.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { BeneficiariosAsistenciaMedicaEntity } from "../datosGenerales/entities/beneficiarios_asistencia_medica_entity";
import { DetalleAsistenciaMedica } from "../datosGenerales/entities/detalle_asistencia_medica";
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { RelacionBeneficiario } from "../datosGenerales/entities/relacion_beneficiario";
import { AsistenciaMedicaEntity } from "../datosGenerales/entities/asistencia_medica_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";
import { FormaPagoEntity } from '../datosGenerales/entities/detalle_vehiculo_entity';

const swal = require("sweetalert2");

declare var jQuery: any;

@Component({
    selector: 'renovacionAsistenciaMedica',
    providers: [RenovacionService],
    templateUrl: 'renovacion-asistencia-medica.template.html',
    styleUrls: ["renovacion.style.css"]
})

export class RenovacionAsistenciaMedica extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    clienteMasivosIndividual: ClienteIndividualEntity;
    asistenciaMedicaActual: DetalleAsistenciaMedica;
    asistenciaMedicaModificado: DetalleAsistenciaMedica;
    beneficiariosExcluidos: BeneficiariosAsistenciaMedicaEntity[];
    beneficiariosNuevos: BeneficiariosAsistenciaMedicaEntity[];
    beneficiariosBandera: boolean;
    nuevoBeneficiario: BeneficiariosAsistenciaMedicaEntity;
    formaPagoSi:number;
    editar: boolean;
    asistencia: AsistenciaMedicaEntity;
    RELACIONES: RelacionBeneficiario[] = [
        { Codigo: 1, Descripcion: 'Conyuge' },
        { Codigo: 2, Descripcion: 'Hijo' },
        { Codigo: 3, Descripcion: 'Hija' }
    ];
    usuarioLogin: UsuarioLoginEntity;

    @ViewChild('incluirBeneficiario')
    modal: ModalComponent;

    constructor(private renovacionService: RenovacionService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService) {
        super();
    }

    ngOnInit() {
        try {
            /*correctHeight();
            detectBody();*/
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.beneficiariosBandera = false;
                    this.editar = true;
                    this.asistenciaMedicaModificado = new DetalleAsistenciaMedica();
                    this.asistenciaMedicaActual = new DetalleAsistenciaMedica();
                    this.asistenciaMedicaActual.FormaPago= new FormaPagoEntity();
                    this.nuevoBeneficiario = new BeneficiariosAsistenciaMedicaEntity();
                    this.beneficiariosExcluidos = new Array<BeneficiariosAsistenciaMedicaEntity>();
                    this.beneficiariosNuevos = new Array<BeneficiariosAsistenciaMedicaEntity>();
                    this.consultarMasivo.iniciarUsuarioMasivo();
                    this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                        datosClienteIndividual => {
                            this.clienteMasivosIndividual = datosClienteIndividual;
                            this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                            sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                        },
                        error => { this.handleError.redirectUrl(error); });
                    this.asistencia = jQuery.parseJSON(this.sesionStorageService.retrieve("AsistenciaMedicaSeleccionada"));
                    this.getAsistencia();
                    this.sesionStorageService.observe("AsistenciaMedicaSeleccionada").subscribe(v => {
                        this.asistencia = jQuery.parseJSON(v);
                        this.getAsistencia();
                    });
                } else {
                    this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
                    let bandera = this.usuarioLogin.Tipo;
                    this.router.navigate(["/login"],bandera);
                }
            }
        } catch (ex) {
            this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login"],bandera);
        }
    }

    getAsistencia() {
        this.renovacionService.datosAsistenciaMedica(this.asistencia).subscribe(
            asistenciaMedica => {
                this.asistenciaMedicaModificado = this.cloneAsistenciaMedica(asistenciaMedica);
                this.asistenciaMedicaModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.asistenciaMedicaActual = asistenciaMedica;
                this.asistenciaMedicaActual.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.formaPagoSi=1;
                if (this.asistenciaMedicaActual.Beneficiarios.length > 0) {
                    this.beneficiariosBandera = true;
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    renovarAsistenciaMedica() {
        this.asistenciaMedicaModificado.Beneficiarios = this.beneficiariosExcluidos;
        this.asistenciaMedicaModificado.BeneficiariosNuevos = this.beneficiariosNuevos;
        this.asistenciaMedicaModificado.MantenerFormaPago = ((this.formaPagoSi == 1) ? true : false);
        this.renovacionService.insertarAsistenciaMedicaRenovacion(this.asistenciaMedicaModificado).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Renovación',
                        text: "Recuerde que los datos seran verificados por un ejecutivo, para hacer efectiva su renovación",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Renovación',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    cloneAsistenciaMedica(c: DetalleAsistenciaMedica) {
        let asistencia = new DetalleAsistenciaMedica();
        for (let prop in c) {
            asistencia[prop] = c[prop];
        }
        return asistencia;
    }

    editarCampos() {
        this.editar = false;
    }

    cancelarEditarCampos() {
        this.editar = true;
        this.asistenciaMedicaModificado = this.cloneAsistenciaMedica(this.asistenciaMedicaActual);
    }

    set dateSTitular(e) {
        this.asistenciaMedicaModificado.FechaNacimientoTitular = new Date(e);
    }

    get dateSTitular() {
        if (this.asistenciaMedicaModificado.FechaNacimientoTitular != undefined) {
            try {
                var a = this.asistenciaMedicaModificado.FechaNacimientoTitular.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.asistenciaMedicaModificado.FechaNacimientoTitular.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

    set dateSBeneficiario(e) {
        this.nuevoBeneficiario.FechaNacimiento = new Date(e);
    }

    get dateSBeneficiario() {
        if (this.nuevoBeneficiario.FechaNacimiento != undefined) {
            try {
                var a = this.nuevoBeneficiario.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.nuevoBeneficiario.FechaNacimiento.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

    modalClose() {
        this.modal.close();
        this.nuevoBeneficiario = new BeneficiariosAsistenciaMedicaEntity();
    }

    modalOpen() {
        this.modal.open();
    }

    incluirNuevoBeneficiario() {
        let codigo = this.nuevoBeneficiario;
        let valor = this.RELACIONES.find(function (el) {
            return el.Codigo == codigo.CodRelacion;
        });
        if (this.nuevoBeneficiario.Codigo == undefined) {
            let date = new Date();
            this.nuevoBeneficiario.Relacion = valor.Descripcion;
            this.nuevoBeneficiario.Codigo = date.getMilliseconds() + date.getFullYear();
            this.beneficiariosNuevos.push(this.nuevoBeneficiario);
        } else {
            this.beneficiariosNuevos.forEach(function (e1) {
                if (e1.Codigo == codigo.Codigo) {
                    e1.Nombre = codigo.Nombre;
                    e1.ApellidoMaterno = codigo.ApellidoMaterno;
                    e1.ApellidoPaterno = codigo.ApellidoPaterno;
                    e1.FechaNacimiento = codigo.FechaNacimiento;
                    e1.Relacion = valor.Descripcion;
                }
            });
        }
        this.modal.close();
        this.nuevoBeneficiario = new BeneficiariosAsistenciaMedicaEntity();
    }

    excluirBeneficiario(beneficiario: BeneficiariosAsistenciaMedicaEntity) {
        this.beneficiariosExcluidos.push(beneficiario);
        this.asistenciaMedicaModificado.Beneficiarios = this.asistenciaMedicaModificado.Beneficiarios.filter(function (el) { return el.Codigo !== beneficiario.Codigo; });
    }

    regresarBeneficiario(beneficiarioExcluido: BeneficiariosAsistenciaMedicaEntity) {
        this.asistenciaMedicaModificado.Beneficiarios.push(beneficiarioExcluido);
        this.beneficiariosExcluidos = this.beneficiariosExcluidos.filter(function (el) { return el.Codigo !== beneficiarioExcluido.Codigo; });
    }

    editarBeneficiarioNuevo(beneficiarioNuevo: BeneficiariosAsistenciaMedicaEntity) {
        this.nuevoBeneficiario = this.cloneBeneficiario(beneficiarioNuevo);
        this.modal.open();
    }

    eliminarBeneficiarioNuevo(beneficiarioNuevo: BeneficiariosAsistenciaMedicaEntity) {
        this.beneficiariosNuevos = this.beneficiariosNuevos.filter(function (el) { return el.Codigo !== beneficiarioNuevo.Codigo; });
    }

    cloneBeneficiario(c: BeneficiariosAsistenciaMedicaEntity) {
        let beneficiario = new BeneficiariosAsistenciaMedicaEntity();
        for (let prop in c) {
            beneficiario[prop] = c[prop];
        }
        return beneficiario;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion-asistencia-medica.component.ts